import { useEffect } from 'react';

const useInterval = (callback, delay, onDestroy = () => {}) => {
  useEffect(() => {
    const interval = setInterval(() =>
        callback()
      , delay || 0);
    return () => {
      onDestroy()
      clearInterval(interval);
    }
  }, [callback, delay]);
}

export default useInterval;
